/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {

    export class ManageSystemCodeModel {
        private systemLevel: Wars.Domain.Model.SystemLevel;

        existingSystemCodes: Array<Wars.Domain.Model.Codes.CodeGroup>;
        addingNewCodeGroup: boolean;
        showInactive: boolean;
        newGroup: Wars.Domain.Model.Codes.CodeGroup;
        editGroup: Wars.Domain.Model.Codes.CodeGroup;
        fieldType: number;

        constructor(
            public id: string,
            private manageSystemCodesService: services.ManageSystemCodesService,
            private systemLevelService: services.SystemLevelService,
            private deleteService: services.DeleteService,
            private modalService: any)
        {
            this.modalService = modalService;

            this.addingNewCodeGroup = false;
            this.existingSystemCodes = [];
            this.loadAllSystemCodes();
            this.showInactive = true;
            this.editGroup = undefined;
        }

        private loadAllSystemCodes(): void {
            if (this.id) {
                this.manageSystemCodesService.getAllCodesForProcessConfiguration(this.id).then(
                    (codeGroups) => {
                        this.existingSystemCodes = codeGroups;
                        this.showInactiveCodes(true);
                    });
            } else {
                this.systemLevelService.getSystemLevelCodes().then(
                (systemLevel) => {
                    this.systemLevel = systemLevel;
                    this.existingSystemCodes = systemLevel.myCodeGroups;
                    this.showInactiveCodes(true);
                });
            }
        }

        private addNewCode(codeGroup: Wars.Domain.Model.Codes.CodeGroup): void {
            var isSystemLevel = !this.id;
            const newCode = this.manageSystemCodesService.createNewSystemCode(codeGroup, isSystemLevel);
            newCode.isActive = true;
            codeGroup.codes.push(newCode);
            newCode.myParentCodeGroup = codeGroup;
        }

        public addNewCodeGroup(): void {
            this.newGroup = this.manageSystemCodesService.createNewEntity<Wars.Domain.Model.Codes.CodeGroup>("CodeGroup");
            this.newGroup.isDocumentTypeCodeGroup = false;
            this.addingNewCodeGroup = true;
            
            this.addNewCode(this.newGroup);
        }

        public cancelNewCodeGroup(): void {
            this.newGroup = undefined;
            this.addingNewCodeGroup = false;
        }

        public addNewCodeToGroup(): void {
            this.addNewCode(this.newGroup);
        }

        public addNewCodeToEditGroup(): void {
            this.addNewCode(this.editGroup);
            this.editExistingCode(this.editGroup.codes[this.editGroup.codes.length - 1]);
        }

        public deleteNewCode(index: number): void {
            this.newGroup.codes.splice(index, 1);
        }
        
        public deleteCodeGroup() {
            var self = this;
            var successCallback = () => {
                self.existingSystemCodes = Enumerable.from(self.existingSystemCodes).where(i => i.id !== self.editGroup.id).toArray();
            }
            self.deleteService.deleteWithModalConfirmationIfNecessary("CodeGroup", self.editGroup.id, "Successfully deleted Code Group", successCallback, "Could not delete Code Group");  
        }

        private saveSucceeded(): void {
            this.existingSystemCodes.push(this.newGroup);
            this.addingNewCodeGroup = false;
            this.newGroup = undefined;
        }

        public saveNewCodeGroup(): void {
            this.newGroup.systemLevel_id = this.systemLevel ? this.systemLevel.id : undefined;
            this.newGroup.mySystemLevel = this.systemLevel;
            this.newGroup.processConfiguration_id = this.id;
            this.manageSystemCodesService.saveAllChanges(() => { this.saveSucceeded(); });
        }

        public showInactiveCodes(showThem: boolean) {
            this.showInactive = showThem;
        }

        public editExistingCode(systemCode: Wars.Domain.Model.Codes.SystemCode) {
            this.showModal(systemCode);
        }

        public inactivateExistingCode(systemCode: Wars.Domain.Model.Codes.SystemCode) {
            systemCode.isActive = false;
            this.manageSystemCodesService.saveAllChanges();
        }

        public changeCodeActiveStatus(systemCode: Wars.Domain.Model.Codes.SystemCode) {
            var self = this;
            self.manageSystemCodesService.saveAllChanges();
            if (!systemCode.isActive) {
                self.systemLevelService.getSystemLevelClaims().then(
                    (systemLevel) => {
                        var claims = systemLevel.myClaims;
                        for (var i = 0; i < claims.length; i++) {
                            for (var j = 0; j < claims[i].claimGrantAuthorities.length; j++) {
                                var grant = claims[i].claimGrantAuthorities[j];
                                var k: number;
                                for (k = 0; k < grant.claimGrantAuthorityValues.length; k++) {
                                    if (grant.claimGrantAuthorityValues[k].mySystemCode.id === systemCode.id) {
                                        grant.claimGrantAuthorityValues[k].granted = false;
                                    }
                                }
                                for (k = 0; k < grant.claimGrantRestrictionValues.length; k++) {
                                    if (grant.claimGrantRestrictionValues[k].mySystemCode.id === systemCode.id) {
                                        grant.claimGrantRestrictionValues[k].restricted = false;
                                    }
                                }
                                self.manageSystemCodesService.saveAllChanges();
                            }
                        }
                    });
            }
        }

        private showModal(systemCode: Wars.Domain.Model.Codes.SystemCode) { // Just provide a template URL, a controller and call 'showModal'.
            this.modalService.showModal({
                templateUrl: "./app/views/modals/_systemCodeEditModal.html",
                controller: "editSystemCodeModalController",
                inputs: {
                    systemCode: systemCode
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        var self = this;
                        self.manageSystemCodesService.saveAllChanges();
                        self.systemLevelService.getSystemLevelClaims().then(
                            (systemLevel) => {
                                var claims = systemLevel.myClaims;
                                for (var i = 0; i < claims.length; i++) {
                                    for (var j = 0; j < claims[i].claimGrantAuthorities.length; j++) {
                                        var grant = claims[i].claimGrantAuthorities[j];
                                        if (grant.myClaimDefinition.codeGroup_id === systemCode.myParentCodeGroup.id) {
                                            var r = self.manageSystemCodesService.createNewEntity<Wars.Domain.Model.ClaimGrantRestrictionValue>("ClaimGrantRestrictionValue");
                                            r.systemLevel_id = grant.systemLevel_id;
                                            r.claimGrantAuthority_id = grant.id;
                                            r.myClaimGrantAuthority = grant;
                                            r.systemCode_id = systemCode.id;
                                            r.restricted = false;   
                                        }
                                        if (grant.myGrantClaimDefinition.codeGroup_id === systemCode.myParentCodeGroup.id) {
                                            var a = self.manageSystemCodesService.createNewEntity<Wars.Domain.Model.ClaimGrantAuthorityValue>("ClaimGrantAuthorityValue");
                                            a.systemLevel_id = grant.systemLevel_id;
                                            a.claimGrantAuthority_id = grant.id;
                                            a.myClaimGrantAuthority = grant;
                                            a.systemCode_id = systemCode.id;
                                            a.granted = false;   
                                        }
                                        self.manageSystemCodesService.saveAllChanges();
                                    }
                                }
                            });
                    } else {
                        this.manageSystemCodesService.rejectChanges();
                    }
                });
            });
        }
    }
}